import type { Testimonial as TestimonialData } from "@/schema/quizSchema";

/**
 * Social-proof quote rendered as a distinct card (accent-bordered, italic quote,
 * optional star row) — visually separate from surrounding body text. Shared by
 * the landing Hero and by info screens that carry a `testimonial`.
 *
 * With `avatar`, the card switches to a photo-beside-quote layout: a circular
 * customer photo to the left, the quote block to the right. Without one, the
 * DOM is unchanged from the plain card.
 */
export function Testimonial({ data }: { data: TestimonialData }) {
  const stars = data.stars !== undefined && (
    <div className="qk-testimonial-stars" aria-label={`${data.stars} out of 5 stars`}>
      {"★".repeat(data.stars)}
    </div>
  );

  if (data.avatar) {
    return (
      <figure className="qk-testimonial qk-testimonial--with-avatar" data-qk-testimonial>
        <img className="qk-testimonial-avatar" src={data.avatar} alt="" loading="lazy" />
        <div className="qk-testimonial-body">
          {stars}
          <blockquote className="qk-testimonial-quote">{data.quote}</blockquote>
          <figcaption className="qk-testimonial-author">— {data.author}</figcaption>
        </div>
      </figure>
    );
  }

  return (
    <figure className="qk-testimonial" data-qk-testimonial>
      {stars}
      <blockquote className="qk-testimonial-quote">{data.quote}</blockquote>
      <figcaption className="qk-testimonial-author">— {data.author}</figcaption>
    </figure>
  );
}
